import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
        windowId: 0,
        tab: {
            id: -1,
            windowId: -1,
        },
        from: {},
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/chrome/runtime/index.js